import { render } from "./MvtAccount.vue?vue&type=template&id=44e82732"
import script from "./MvtAccount.vue?vue&type=script&lang=js"
export * from "./MvtAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__